<template>
  <div id="app">
    <LandingComponent/>
    <ProjectsContainerComponent/>
    <TeamComponent/>
    <FooterComponent/>
    <router-view class="footer"/>
  </div>
</template>

<script>
// Import Libraries
import Rellax from 'rellax';
import ScrollReveal from 'scrollreveal';

//Import Sub-components
import NavbarComponent from './components/Intro/Navbar.vue';
import ProjectsContainerComponent from './components/Apps/ProjectsContainer.vue';
import LandingComponent from './components/Intro/Landing.vue';
import TeamComponent from './components/Team/Team.vue';
import FooterComponent from './components/Footer/Footer.vue';


export default {
  name: 'App',
  components: {
    NavbarComponent,
    ProjectsContainerComponent,
    LandingComponent,
    TeamComponent,
    FooterComponent
  },
    mounted() {
    // Reveal animations
    var slideUp = {
        easing: 'cubic-bezier(0.25,0.46,0.45,0.94)',
        distance: '3em',
        origin: 'bottom',
        reset: false,
        interval: 500,
        duration: 1000,
		delay: 200,
		mobile: false,
    };

    ScrollReveal().reveal('#intro.reveal', slideUp);
    ScrollReveal().reveal('#greo.reveal', slideUp);
    ScrollReveal().reveal('#tldr.reveal', slideUp);
    ScrollReveal().reveal('#stashe.reveal', slideUp);
    ScrollReveal().reveal('#team.reveal', slideUp);

    var rellax = new Rellax('.rellax', {
		center: true,
    });
  },
};
</script>

<style lang="scss">

@mixin breakpoint1 { @media only screen and (min-width: 0px) { @content; } }
@mixin breakpoint2 { @media only screen and (min-width: 750px) { @content; } }
@mixin breakpoint3 { @media only screen and (min-width: 1024px) { @content; } }


#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #FFFFFF;
  background-color: #141516;
  margin: 0 0 0 0px;
}

@font-face {
  font-family: 'Mont-Heavy';
  src: url('./assets/fonts/mont/Mont-HeavyDemo.otf') format('opentype');
}

.footer {
  position: fixed;
}

</style>



// WEBPACK FOOTER //
// src/App.vue